<template>
  <div>
    <span id="topo"></span>

    <z-centralized-toolbar>
      <v-btn text rounded color="primary" :disabled="salvando" @click="cancelar">
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar
      </v-btn>
      <!-- <v-spacer></v-spacer> -->


      <template v-slot:actions>
        <!-- <v-btn text :disabled="salvando || finalizando" @click="cancelar">Cancelar</v-btn> -->
        <!-- <v-chip v-if="!isAdicionando" :color="corChip(pedidocompra.status)" dark>{{ pedidocompra.status }}</v-chip>

        <v-divider vertical class="mx-4" v-if="!isAdicionando"></v-divider> -->
        <v-btn
          text
          rounded
          :disabled="salvando"
          @click="$router.push({name: 'PedidosCompraLista'})"
        >Cancelar</v-btn>
        <v-btn rounded depressed color="primary" :disabled="isVisualizando || !form_valido" :loading="salvando" @click="salvar">
          Salvar Pedido
        </v-btn>
      </template>
    </z-centralized-toolbar>

    <v-form ref="form" v-model="form_valido" lazy-validation>
      <z-container>
        <h3 class="text-body-1 mb-3">Pedido de Compra</h3>

        <!-- <v-tabs class="mb-2" v-model="tab" background-color="transparent" color="primary">
          <v-tab>Pedido de Compra</v-tab>
          <v-tab>Pagamentos</v-tab>
        </v-tabs> -->

            <v-card class="mb-3">
              <v-toolbar flat color="white" dense>
                <span class="text-subtitle-2">Dados do Pedido</span>
              </v-toolbar>
    
              <v-divider></v-divider>
    
              <div>
                <v-card-text class="text--primary">
                  <v-row dense>
                    <v-col col="12" sm="2">
                      <v-text-field 
                        label="Número" 
                        v-model="pedidocompra.id" 
                        disabled 
                        filled 
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col col="12" sm="2">
                      <z-date-picker-menu 
                        v-model="pedidocompra.data_emissao" 
                        label="Data" 
                        filled 
                        dense
                        hide-details
                        readonly
                        disabled
                      ></z-date-picker-menu>
                    </v-col>
                    <v-col col="12" sm="8">
                      <v-autocomplete 
                        v-model="pedidocompra.fornecedor_id" 
                        label="Fornecedor" 
                        filled 
                        dense
                        hide-details
                        :items="fornecedores" 
                        :rules="[regras.campoObrigatorio]"
                        :disabled="isEditando || isVisualizando"
                      ></v-autocomplete>
                    </v-col>
                    <!-- <v-col col="12" sm="2">
                      <v-select 
                        v-model="pedidocompra.status" 
                        label="Status" 
                        filled 
                        dense
                        hide-details
                        :items="['Pendente','Cancelado','Entregue']"
                        :disabled="isVisualizando"
                      ></v-select>
                    </v-col> -->
                  </v-row>
                  <!-- <v-row dense>
                    <v-col col="12" sm="3">
                      <v-select 
                        v-model="pedidocompra.vendedor_id" 
                        label="Vendedor"
                        filled 
                        dense
                        :items="$store.getters['listas/vendedores']" 
                        :rules="[regras.campoObrigatorio]" 
                      ></v-select>
                    </v-col>
                  </v-row> -->
                </v-card-text>
              </div>
            </v-card>

            <adicionar-produto 
              class="mb-3 sticky" 
              ref="adicionarProduto"
              movimento-estoque
              somar-produtos
              permitir-produtos-duplicados
              somente-quantidade
              tela="pedido_compra"
              :produtos="pedidocompra.itens"
              :total="valor_total"
              v-if="exibirAdicionarProduto"
            ></adicionar-produto>
    
            <v-card class="mb-3">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Produtos</h3>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-divider></v-divider>
  
              <v-data-table 
                hide-default-footer 
                disable-pagination
                disable-sort
                item-key="id" 
                :headers="headers" 
                :items="pedidocompra.itens" 
                :loading="false"
              >
              
                <template v-slot:item.index="{ index }">
                  {{ index + 1 }}
                </template>

                <template v-slot:item.quantidade="{ item }">
                  {{ item.quantidade | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }} {{ item.unidade }}
                </template>

                <template v-slot:item.quantidade_entregue="{ item }">
                  {{ item.quantidade_entregue | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }} {{ item.unidade }}
                </template>

                <template v-slot:item.opcoes="{ item }">
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="abrirEntradaProdutos(item)" tabindex="-1">
                        <v-icon>mdi-tray-arrow-down</v-icon>
                      </v-btn>
                    </template>
                    <span>Lançar Entrada</span>
                  </v-tooltip> -->
                  <v-btn icon @click="excluirProduto(item)" tabindex="-1">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn v-if="item.agendamento?.length > 0" icon tabindex="-1" @click="$refs.dialogoExibirAgendamento.abrir(item)">
                    <v-icon>mdi-calendar</v-icon>
                  </v-btn>
                </template>

                <template v-slot:body.append="{ headers }">
                <tr>
                  <td class="text-right" colspan="4">
                    <b>{{ quantidade_pedido_total | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }}</b>
                  </td>

                </tr>
              </template>

              </v-data-table>
            </v-card>
  
            <v-card class="mb-3">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Observações</h3>
              </v-toolbar>
  
              <v-divider></v-divider>
  
              <v-card-text class="text--primary">
                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-textarea v-model="pedidocompra.observacoes" label="Observações" rows="3" filled dense></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>


      </z-container>
    </v-form>

    <z-dialogo-sim-nao
      ref="dialogoRemoverItem"
      titulo="Remover item"
      botaoSim="Remover"
      botaoNao="Não Remover"
    >
      O item será removido do pedido de compra. Deseja remover?
    </z-dialogo-sim-nao>

    <!-- <dialogo-entrada-produtos ref="dialogoEntradaProdutos"></dialogo-entrada-produtos> -->

    <DialogoExibirAgendamento 
      ref="dialogoExibirAgendamento"
    ></DialogoExibirAgendamento>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
import BuscaProduto from "../pedidos/BuscaProduto";
import DialogoBuscarProduto from "../pedidos/DialogoBuscarProduto";
import DialogoExibirAgendamento from "../produtos/controle/DialogoExibirAgendamento.vue";
// import { createLocalStorage } from "@/app/utils/LocalStorage";
// import config from "@/app/config";
import { trunc } from "@/app/helpers/conversoes";

import * as regras from "@/app/helpers/validacoes";

// import DialogoEntradaProdutos from "./DialogoEntradaProdutos";
import PedidosCompraPagamentos from "./PedidosCompraPagamentos.vue";
import AdicionarProduto from "@/pages/produtos/AdicionarProduto";
import AdicionarProdutoModal from "@/pages/produtos/AdicionarProdutoModal";

// const storage = createLocalStorage(config);

export default {
  name: "PedidosCompraForm",

  components: {
    BuscaProduto,
    DialogoBuscarProduto,
    // DialogoEntradaProdutos,
    PedidosCompraPagamentos,
    AdicionarProduto,
    AdicionarProdutoModal,
    DialogoExibirAgendamento,
  },

  data() {
    return {
      pedido: {
        cliente_id: null,
        data: this.hoje(),
        itens: 0,
        quantidade_total: 0,
        frete: 0,
        taxa_valor: 0,
        desconto_valor: 0,
        tipo_desconto: "R$",
        valor_bruto: 0,
        valor_liquido: 0,
        forma_pagamento: "Depósito Bancário",
        observacoes: "",
        produtos: [],
      },
      produto: {
        referencia: null,
        descricao: null,
        unidade: null,
        quantidade: 0,
        valor: 0,
        subtotal: 0,
        estoque: 0,
      },
      salvando: false,
      adicionando: false,
      visualizando: false,
      form_valido: false,
      hidedetails: true,
      buscando: false,
      labelQuantidade: "Quantidade",
      headers: [
        { text: "Item", value: "index", width: "80px" },
        { text: "Referência", value: "referencia", width: "110px" },
        { text: "Descrição", value: "descricao", sortable: false },
        { text: "Quantidade", value: "quantidade", align: "right" },
        { text: "Recebido", value: "quantidade_entregue", align: "right" },
        // { text: "Valor Custo", value: "valor", width: "150px", align: "right", sortable: false },
        // { text: "SubTotal", value: "subtotal", width: "150px", align: "right" },
        { text: "Opções", value: "opcoes", width: "200px", align: "center" },
      ],
      loading: false,
      regras: regras,
      tab: '',
    };
  },

  computed: {
    ...mapGetters('listas', ['fornecedores', 'vendedores']),
    ...mapState('pedidoscompra', ['pedidocompra']),

    isEditando() {
      return this.$route.name == "PedidosCompraEditar";
    },

    isVisualizando() {
      return this.$route.name == "PedidosCompraVisualizar";
    },

    isAdicionando() {
      return this.$route.name == "PedidosCompraAdicionar";
    },

    quantidade_pedido_total() {
      return this.pedidocompra.itens.reduce((soma, produto) => soma + Number(produto.quantidade), 0);
    },

    quantidade_entregue_total() {
      return this.pedidocompra.itens.reduce((soma, produto) => soma + Number(produto.quantidade_entregue), 0);
    }, 

    valor_total() {
      return this.pedidocompra.itens.reduce((soma, produto) => soma + Number(produto.quantidade * produto.valor), 0);
    },

    config() {
      return this.$store.state.configuracoes;
    },

    exibirAdicionarProduto() {
      if (this.isVisualizando) {
        return false;
      }

      return !this.config.USAR_ADICIONAR_PRODUTO_MODAL;
    },
  },

  beforeMount() {
    this.$store.dispatch("carregarConfiguracoes");
    this.$store.dispatch("listas/fornecedores");
    this.$store.dispatch("listas/vendedores");
  },

  beforeRouteLeave(to, from, next) {
    this.UNSET_PEDIDOCOMPRA();
    next();
  },

  async mounted() {
    this.setTitulo('Pedido de Compra');
    this.$store.dispatch("listas/fornecedores");
    this.$store.dispatch("listas/lojas");

    if (["PedidosCompraEditar", "PedidosCompraVisualizar"].includes(this.$route.name) && this.$route.params.id) {
      try {
        await this.abrir(this.$route.params.id);
      } catch (error) {
        this.$eventbus.erro("Não foi possível abrir este pedido.", error);
        this.$router.push({ name: "PedidosCompraListar" });
      }
    } else {
      this.pedidocompra.data_emissao = this.hoje();
    }
  },

  methods: {
    ...mapMutations('pedidoscompra', ['setTitulo', 'LOADING_OFF', 'SET_PEDIDOCOMPRA', 'UNSET_PEDIDOCOMPRA']),
    ...mapActions('pedidoscompra', ['abrir']),

    async salvar() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      try {
        this.salvando = true;
        this.pedidocompra.valor_total = this.valor_total;
        if (this.isEditando) {
          await this.$store.dispatch('pedidoscompra/atualizar', this.pedidocompra);
        } else {
          await this.$store.dispatch('pedidoscompra/salvar', this.pedidocompra);
        }
        
        this.$eventbus.notificar('Pedido de compra salvo com sucesso.');
        this.$router.push({ name: "PedidosCompraLista" });
      } catch (error) {
        this.$eventbus.erro("Não foi possível salvar este pedido. Verifique os dados preenchidos.");
        throw error;
      } finally {
        this.salvando = false
      }
    },

    cancelar() {
      this.$router.push({ name: "PedidosCompraLista" });
    },

    // abrirEntradaProdutos(item) {
    //   this.$refs.dialogoEntradaProdutos.abrir(item);
    // },


    corChip(situacao) {
      switch (situacao) {
        case "Pendente":
          return "orange";
          break;

        case "Parcial":
          return "orange";
          break;

        case "Cancelado":
          return "red";
          break;

        case "Entregue":
          return "green";
          break;

        default:
          break;
      }
    },

    calcularTotais() {
      let desconto;


      this.pedidocompra.quantidade_total = this.produtos.reduce((soma, produto) => soma + Number(produto.quantidade), 0);
      this.pedidocompra.valor_bruto = trunc(this.produtos.reduce((soma, produto) => soma + produto.subtotal, 0));

      if (this.pedidocompra.tipo_desconto == "R$") {
        desconto = Number(this.pedidocompra.desconto_valor);
      } else {
        desconto = this.pedidocompra.valor_bruto * (Number(this.pedidocompra.desconto_valor) / 100);
      }

      this.pedidocompra.valor_liquido = trunc(
        this.pedidocompra.valor_bruto +
        Number(this.pedidocompra.taxa_valor) -
        Number(desconto) +
        Number(this.pedidocompra.frete)
      );
    },


    async excluirProduto(produto) {
      let response = await this.$refs.dialogoRemoverItem.abrir();
      if (response == false) {
        return;
      }

      let index = this.pedidocompra.itens.findIndex((p) => p == produto);
      this.pedidocompra.itens.splice(index, 1);
      this.$refs.dialogoRemoverItem.fechar();
      this.$refs.adicionarProduto.focus();

      // this.calcularTotais();
    },
  },

};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */

.sticky {
  position: sticky;
  top: 128px;
  z-index: 2;
}

.trasparente>>>.v-input__slot {
  background: none;
}
</style>
